import React from 'react';
import { Box, Container, Typography, Stack } from '@mui/material';
import MeetSara from '../components/MeetSara';
import WhyThisBook from '../components/WhyThisBook';
import Footer from '../components/Footer';
const About = () => {
  return (
    <Box
      sx={{
        bgcolor: 'background.default',
        color: 'text.primary',
        minHeight: '100vh',
      }}
    >
      <Box

      >
        <Stack spacing={{ xs: 2, md: 4 }} sx={{ alignItems: 'center', mb: 6 }}>
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '2rem', sm: '2.4rem', md: '3rem' },
              textAlign: { xs: 'center', md: 'left' },
              fontWeight: 700,
            }}
          >
            About Sara & The Journey
          </Typography>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 500,
              color: 'text.secondary',
              textAlign: { xs: 'center', md: 'left' },
              fontSize: { xs: '1.1rem', md: '1.25rem' },
            }}
          >
            Learn more about the heart and science behind Sara's work empowering families.
          </Typography>
          {/* Full-width stacking to avoid layout issues from nested component containers */}
          <MeetSara />
          {/* <WhyThisBook /> */}
        </Stack>
      </Box>
    </Box>
  );
};

export default About;